import { useState } from "react";
import { useMutation } from "convex/react";
import { api } from "@constructionautomation/backend";
import type { Id } from "@constructionautomation/backend/convex/_generated/dataModel";
import { toast } from "sonner";

type GenerateOptions = {
  selectedCount: number;
  successMessage: string;
  errorMessage: string;
  emptySelectionMessage?: string;
};

export function useSubmittalGeneration(submittalId: Id<"specPilotSubmittals">) {
  const generateSubmittal = useMutation(api.specPilot.generatedSubmittals.generate);
  const [isGenerating, setIsGenerating] = useState(false);

  async function runGeneration({
    selectedCount,
    successMessage,
    errorMessage,
    emptySelectionMessage,
  }: GenerateOptions): Promise<boolean> {
    if (selectedCount === 0) {
      if (emptySelectionMessage) {
        toast.error(emptySelectionMessage);
      }
      return false;
    }

    setIsGenerating(true);
    try {
      await generateSubmittal({ submittalId });
      toast.success(successMessage);
      return true;
    } catch (error) {
      toast.error(errorMessage);
      console.error(error);
      return false;
    } finally {
      setIsGenerating(false);
    }
  }

  return {
    isGenerating,
    runGeneration,
  };
}
